module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/perform.js
// module id = 435
// module chunks = 3